<article class="service-card" [ngClass]="view" [class.not-available]="!service?.can?.signup"
         [attr.data-test]="'card_service'"
         itemscope
         itemtype="https://schema.org/Article">
  <ng-container *ngTemplateOutlet="meta"></ng-container>
  <div class="card-cover" (click)="onOpenCardInModal()"></div>

  <div class="cover-wrap">
    <on-ui-cover [cover]="cardData?.cover" [scale]="doHover" [withBlur]="true" [attr.data-test]="'card_service_cover'"></on-ui-cover>
    <div class="bookmark">
      <app-bookmark [notooltip]="true" [item]="service" [type]="'service'" (favoriteChanged)="favoriteChanged($event)"></app-bookmark>
    </div>
  </div>

  <div class="main-info-wrap">
    <div class="type" [attr.data-test]="'card_service_type'" [ngClass]="eUserServiceType[cardData?.type]">{{ typeLabel(cardData?.type) | customLocale }}</div>
    <div class="subject-wrap" [attr.data-test]="'card_service_subject'">
      <span class="subject">{{ cardData?.subjectTitle }}</span>
      <ng-template [ngIf]="cardData?.subjectIsNative">
        <span class="native">{{ 'library.user-service-card.native' | customLocale }}</span>
      </ng-template>
    </div>
    <div class="title" [attr.data-test]="'card_service_title'">
      <a [href]="cardData?.userServiceRoute" class="no-link">
        {{ cardData?.title | striptags }}
      </a>
    </div>
    <ng-container *ngTemplateOutlet="secondInfo"></ng-container>
    <div class="author-block">
      <div class="avatar-wrap" [class.school-avatar-wrap]="school">
        <on-ui-cover [cover]="school ? cardData.schoolCover : cardData?.userAvatar"
                     [attr.data-test]="'card_service_author_avatar'"></on-ui-cover>
      </div>
      <div class="teacher-name" itemprop="author"
           [attr.data-test]="'card_service_author_name'">{{ school ? cardData.schoolTitle : cardData?.userpicFullname }}</div>
      <app-rating [stats]="school ? school : cardData?.authorStats"></app-rating>
    </div>
    <div class="price-block" *ngIf="view !== 'wide-horizontal'">
      <ng-container *ngIf="service?.can?.signup">
<!--        <div class="old-price">-->
<!--          <ng-template [ngIf]="cardData?.discount">-->
<!--            <span class="price-without-discount">-->
<!--              {{ formatPriceWithoutDiscount(getPriceTier(cardData?.price_tier) | async) }}-->
<!--            </span>-->
<!--            <div class="discount">{{ cardData?.discount }}% {{ 'library.user-service-card.discount' | customLocale }}</div>-->
<!--          </ng-template>-->
<!--        </div>-->
        <div class="current-price">
          <span class="price" [attr.data-test]="'card_service_price'">{{  getFormattedAmount() | async }}</span>
          <span class="period">{{ labelPeriod | customLocale }}</span>
        </div>
      </ng-container>
      <ng-container *ngIf="!service?.can?.signup">
        <div class="not-available bold">
          {{ 'library.user-service-card.unavailable' | customLocale }}
        </div>
      </ng-container>
    </div>
  </div>
</article>

<ng-template #secondInfo>
  <div class="second-info">
    <ul class="info-list">
      <li>{{ (isSingle ? 'library.user-service-card.one-on-one' : 'library.user-service-card.group') | customLocale }}</li>
      <ng-template [ngIf]="view !== 'wide-horizontal'">
        <li *ngIf="isRegularClass">{{ 'teacher-card.stats.classes' | customLocale}} {{ 'event-calendar.ongoing' | customLocale }}</li>
        <li *ngIf="!isRegularClass && cardData?.meetings_limit">{{ 'teacher-card.stats.classes' | customLocale}} {{ cardData?.meetings_limit }}</li>
        <li>{{ 'user-service-form-3.fields.label9' | customLocale }} {{ cardData?.age_from }}-{{ formatAge(cardData?.age_to) }}</li>
      </ng-template>
    </ul>
    <ul class="info-list">
      <ng-template [ngIf]="view !== 'wide-horizontal'">
        <li *ngIf="weekdaysToString()">{{ weekdaysToString() }}</li>
        <li>{{ cardData?.duration }} {{ 'library.user-service-card.min' | customLocale }}</li>
      </ng-template>
    </ul>
    <ul class="info-list">
      <li>{{ 'constructor.form-language-label' | customLocale }}: {{ cardData.languageTitle }}</li>
      <li *ngIf="view === 'wide-horizontal'" [ngClass]="eUserServiceType[cardData?.type]">{{ typeLabel(cardData?.type) | customLocale }}</li>
    </ul>
  </div>
</ng-template>

<ng-template #meta>
  <meta itemprop="url" content="{{ cardData?.userServiceRoute }}"/>
  <meta itemprop="name" content="{{ cardData?.fullTitle }}"/>
  <meta itemprop="datePublished" content="{{ hlp_dateToISOString(cardData?.contentDate) }}"/>
  <meta itemprop="image" content="{{ cardData?.metaImageUrl || cardData?.coverImageUrl }}"/>
  <meta *ngIf="cardData?.description" itemprop="description" content="{{ cardData?.description | striptags }}"/>
  <meta itemprop="headline" content=""/>
  <!-- <meta itemprop="publisher" content="htts://onclass.com"/> -->
  <!-- keywords -->
  <meta itemprop="inLanguage" content="{{ service.language?.code }}"/>
  <!-- discussionUrl -->
  <!-- <meta *ngIf="service.stats?.comments_count" itemprop="commentCount" content="{{ service.stats?.comments_count }}"/>-->
</ng-template>
